import React, { Component } from 'react';
import './FiltersOnMap.css';
import { inject, observer } from 'mobx-react';

import { SwapIcon, LockIcon, BellIcon, ParkedIcon } from '../../../common/icons';

const FilterButton = props => (
  <div className={`button ${props.disabled ? 'disabled' : props.selected ? 'selected' : ''} ${props.className}`} onClick={props.onClick}>
    <div className="buttonInner" >
      <div>
        {props.icon}
        <div className="value" style={{ marginLeft: '7px' }} >
          {props.value}
        </div>
      </div>
      <div className="label">{props.label}</div>
    </div>
  </div>
);

@inject('translationsStore')
@observer
export default class FiltersOnMap extends Component {

  componentDidMount = () => {
  }

  componentWillUnmount = () => {
  }

  toggleFilter = (name, reload = true) => {
    this.props.onToggleFilter(name, reload);
  };

  removeFilter = name => {
    this.props.onRemoveFilter(name);
  };

  apply = () => {
    this.props.onApplyFilter();
  };

  isFilterSelected = name => !!this.props.filters[`${name}`];

  isFilterDisabled = (filter) => {
    if(filter===0) {
      return true;
    }
    return false;
  }
 
  render() {
    const { translationsStore, carsFilters } = this.props;
    
    return (
      <div className={`FiltersOnMap ${this.props.visibleFilters ? 'filtersOpen' : 'filtersClosed'}`} style={this.props.style}>
        <div className="leftfilters">
          <div className={`together ${this.isFilterSelected('withEngineOn') ? 'selected' : this.isFilterSelected('withEngineOff') ? 'selected' : ''}`}>
            <FilterButton
              label={translationsStore.translate('filtersOnMap.button.acceso')}
              icon={<SwapIcon />}
              value={carsFilters.withEngineOn}
              disabled={this.isFilterDisabled(carsFilters.withEngineOn)}
              onClick={() => {
                if (this.isFilterDisabled(carsFilters.withEngineOn))
                return false;
                this.removeFilter('withEngineOff')
                this.toggleFilter('withEngineOn')
                this.apply();
                 
              }}
              selected={this.isFilterSelected('withEngineOn')}
              className="withEngineOn"
            />
            <FilterButton
              label={translationsStore.translate('filtersOnMap.button.spento')}
              icon={<ParkedIcon />}
              disabled={this.isFilterDisabled(carsFilters.withEngineOff)}
              value={carsFilters.withEngineOff}
              onClick={() => {
                if (this.isFilterDisabled(carsFilters.withEngineOff))
                return false;
                this.removeFilter('withEngineOn');
                this.toggleFilter('withEngineOff');
                this.apply();
              }}
              selected={this.isFilterSelected('withEngineOff')}
              className="withEngineOff"
            />
          </div>
          <div style={{ marginLeft: '5px' }} className={`together ${this.isFilterSelected('withLockOn') ? 'selected' : this.isFilterSelected('withLockOff') ? 'selected' : ''}`}>
            <FilterButton
              label={translationsStore.translate('filtersOnMap.button.lockon')}
              icon={<LockIcon />}
              disabled={this.isFilterDisabled(carsFilters.withLockOn)}
              value={carsFilters.withLockOn}
              onClick={() => {
                if (this.isFilterDisabled(carsFilters.withLockOn))
                return false;
                this.removeFilter('withLockOff');
                this.toggleFilter('withLockOn');
                this.apply();
              }}
              selected={this.isFilterSelected('withLockOn')}
              className="withLockOn"
            />
            <FilterButton
              label={translationsStore.translate('filtersOnMap.button.lockoff')}
              icon={<LockIcon />}
              disabled={this.isFilterDisabled(carsFilters.withLockOff)}
              value={carsFilters.withLockOff}
              onClick={() => {
                if (this.isFilterDisabled(carsFilters.withLockOff))
                return false;
                this.removeFilter('withLockOn');
                this.toggleFilter('withLockOff');
                this.apply();
              }}
              selected={this.isFilterSelected('withLockOff')}
              className="withLockOff"
            />
          </div>
          <FilterButton
            label={translationsStore.translate('filtersOnMap.button.notice')}
            icon={<BellIcon />}
            disabled={this.isFilterDisabled(carsFilters.withNotices)}
              value={carsFilters.withNotices}
            onClick={() => {
              if (this.isFilterDisabled(carsFilters.withNotices))
              return false;
              this.toggleFilter('withNotices');
              this.apply();
            }}
            selected={this.isFilterSelected('withNotices')}
            className="withNotices"
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/FiltersOnMap/FiltersOnMap.js